"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const images_1 = require("../../../../assets/images");
const components_1 = require("../../../../components");
const CustomText_1 = __importDefault(require("../../../../components/text/CustomText"));
const constants_1 = require("../../../../constants");
const rootNavigation_1 = require("../../../../navigators/rootNavigation");
const Routes_1 = __importDefault(require("../../../../navigators/Routes"));
const styles_1 = __importDefault(require("../styles"));
const AccountItem = ({ userInfo, idx, onSubmit, tabIndex }) => {
    const navigateToUserProfile = () => {
        (0, rootNavigation_1.navigate)(Routes_1.default.HIDDEN_TAB_NAVIGATOR, {
            screen: Routes_1.default.USER_PROFILE,
            params: {
                userHandle: userInfo?.user_handle,
            },
        });
    };
    return (react_1.default.createElement(react_native_1.View, { style: styles_1.default.accountItem },
        react_1.default.createElement(react_native_1.TouchableOpacity, { onPress: () => {
                navigateToUserProfile();
            } },
            react_1.default.createElement(react_native_1.Image, { resizeMode: "cover", source: userInfo.thumbnail_url || images_1.images.AvatarDefaul, style: styles_1.default.accountItemAvatar })),
        react_1.default.createElement(react_native_1.Pressable, { style: styles_1.default.accountItemInfo, onPress: () => {
                navigateToUserProfile();
            } },
            react_1.default.createElement(CustomText_1.default, { weight: "600", numberOfLines: 1, style: styles_1.default.accountItemName }, userInfo.nickname || constants_1.DEFAULT_NAME),
            react_1.default.createElement(CustomText_1.default, { numberOfLines: 1, style: styles_1.default.accountItemTagName },
                "@",
                userInfo.user_handle)),
        userInfo.is_blocked ? (react_1.default.createElement(react_native_1.TouchableOpacity, { onPress: () => onSubmit(userInfo.user_id, idx), style: [styles_1.default.accountItemButton, { backgroundColor: '#DDDDDD' }] },
            react_1.default.createElement(CustomText_1.default, { style: styles_1.default.accountItemButtonLabel }, tabIndex == 0 ? 'ブロック解除' : 'ミュート解除'))) : (react_1.default.createElement(components_1.BorderButton, { title: tabIndex == 0 ? 'ブロック' : 'ミュート', style: styles_1.default.accountItemButton, textStyle: [
                styles_1.default.accountItemButtonLabel,
                {
                    color: '#1960B0',
                },
            ], onPress: () => onSubmit(userInfo.user_id, idx) }))));
};
exports.default = AccountItem;
